import * as React from 'react';

import type { LearnerOnboarding_Goal as LearnerGoal } from '__generated__/graphql-types';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import { formatRoleIdToString } from 'bundles/enterprise-learner-onboarding/utils';
import mapGoalToText from 'bundles/program-personalized-tab/utils/mapGoalToText';

import _t from 'i18n!nls/enterprise-legacy-learner-home';

export const getEnterpriseLearningGoalCopy = (
  hasCompletedOnboarding: boolean,
  onboardingRoleId?: string | null,
  onboardingGoals?: LearnerGoal[] | null,
  isUnsureOfRole?: boolean
) => {
  let message;
  if (!hasCompletedOnboarding) {
    message = <FormattedHTMLMessage message={_t('Your career goal is <strong>pending</strong>')} />;
  } else {
    const mappedGoals = onboardingGoals?.map((selectedGoal) => mapGoalToText(selectedGoal));
    if (isUnsureOfRole) {
      if (mappedGoals && mappedGoals.length > 1) {
        message = (
          <FormattedHTMLMessage
            message={_t(
              'Your career goal is to <strong>{mappedGoalsList}</strong> and <strong>{lastMappedGoal}</strong>'
            )}
            mappedGoalsList={mappedGoals.slice(0, -1).join(', ')}
            lastMappedGoal={mappedGoals[mappedGoals.length - 1]}
          />
        );
      } else if (mappedGoals) {
        message = (
          <FormattedHTMLMessage
            message={_t('Your career goal is to <strong>{mappedGoal}</strong>')}
            mappedGoal={mappedGoals[0]}
          />
        );
      }
    } else if (onboardingRoleId) {
      const formattedRoleId = formatRoleIdToString(onboardingRoleId);

      if (mappedGoals && mappedGoals.length > 1) {
        message = (
          <FormattedHTMLMessage
            message={_t(
              'Your career goal is to <strong>{mappedGoalsList}</strong> and <strong>{lastMappedGoal}</strong> as a(n) <strong>{selectedRole}</strong>'
            )}
            mappedGoalsList={mappedGoals.slice(0, -1).join(', ')}
            lastMappedGoal={mappedGoals[mappedGoals.length - 1]}
            selectedRole={formattedRoleId}
          />
        );
      } else if (mappedGoals) {
        message = (
          <FormattedHTMLMessage
            message={_t('Your career goal is to <strong>{mappedGoal}</strong> as a(n) <strong>{selectedRole}</strong>')}
            mappedGoal={mappedGoals[0]}
            selectedRole={formattedRoleId}
          />
        );
      }
    }
  }
  return message;
};
